// NATIVE


// INSTALLED
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';


// CUSTOM
import { Areas } from '../pages/area';
import { Cargos } from '../pages/cargos';
import { Main } from '../modules/main/Main';
import { LogAcciones } from '../pages/logAcciones';
import { Compania } from '../pages/company/Compania';
import { Sucursal } from '../pages/sucursal/Sucursal';
import { CrearEmpresa, DetalleCompania, EditarCompania } from '../pages/company';
import { CrearSucursalEmpresa, DetalleSucursal, EditarSucursal } from '../pages/sucursal';


// MANAGER 
import { Turnos } from '../pages/turnos';
import { Employees } from '../pages/employee';
import { CreateCustomer, Customer } from '../pages/customers';
import { CreateEmployee } from '../pages/employee/CreateEmployee';
import { ControlTiempos } from '../pages/controlTiempos/ControlTiempos';
import { Parametros } from '../pages/parametros/Parametros';
import { Novedades } from '../pages/novedades/Novedades';
import { UsuariosPermisos } from '../pages/usuariosPermisos/UsuariosPermisos';
import { DetailCustomer } from '../pages/customers/DetailCustomer';
import { EditCustomer } from '../pages/customers/EditCustomer';
import { TipoNovedades } from '../pages/novedades/TipoNovedades';
import { NovedadesTurnos } from '../pages/novedades/NovedadesTurnos';
import { DetailEmployee } from '../pages/employee/DetailEmployee';
import { DetailUsuarioPermissions, EditUserPermissions } from '../pages/usuariosPermisos';
import { GenerarPorConfiguracion, TurnosEmpleados } from '../pages/turnosEmpleados';
import { Terminals } from '../pages/terminals';



export const PrivateRoutes = () => {

  const location = useLocation();

  return (
      <Routes>
        <Route path="/" element={<Main />} > 

          {/* MANAGER  */}
          <Route path="/manager/clientes" element={<Customer />} /> 
          <Route path="/manager/crear-cliente" element={<CreateCustomer />} />
          <Route path="/manager/clientes/detalle-cliente" element={<DetailCustomer />} />
          <Route path="/manager/clientes/editar-cliente" element={<EditCustomer />} />


          
          {/* USUARIOS PERMISOS  */}
          <Route path="/manager/usuarios-permisos" element={<UsuariosPermisos />} />
          <Route path="/manager/usuarios-permisos/detalle" element={<DetailUsuarioPermissions />} />
          <Route path="/manager/usuarios-permisos/editar" element={<EditUserPermissions />} />
         

          {/* COMPAÑIA  */}
          <Route path="/configuracion/compania" element={<Compania />} />
          <Route path="/configuracion/crear-compania" element={<CrearEmpresa />} />
          <Route path="/configuracion/compania/detalle-compania" element={<DetalleCompania />} />
          <Route path="/configuracion/compania/editar-compania" element={<EditarCompania />} />


          {/* AREAS  */}
          <Route path="/configuracion/areas" element={<Areas />} />
          

          {/* CARGOS  */}
          <Route path="/configuracion/cargos" element={<Cargos />} />


          
          {/* USUARIO PERMISOS  */}
          <Route path="/configuracion/usuarios-permisos" element={<UsuariosPermisos />} />


          {/* LOGS  */}
          <Route path="/configuracion/logs" element={<LogAcciones />} />

          
          
          {/* EMPLEADOS  */}
          <Route path="/talento-humano/empleado" element={<Employees />} />
          <Route path="/talento-humano/crear-empleado" element={<CreateEmployee />} />
          <Route path="/talento-humano/empleado/detalle" element={<DetailEmployee />} />



          {/* TURNOS  */}
          <Route path="/talento-humano/turnos" element={<Turnos />} />
          <Route path="/talento-humano/generar-por-configuracion" element={<GenerarPorConfiguracion />} />


          {/* TURNOS EMPLEADOS  */}
          <Route path="/talento-humano/turnos-empleados" element={<TurnosEmpleados />} />
          

          


          {/* CONTROL TIEMPOS  */}
          <Route path="/talento-humano/control-tiempos" element={<ControlTiempos />} />



          
          {/* PARAMETROS  */}
          <Route path="/talento-humano/parametros" element={<Parametros />} />


          
          {/* TIPO NOVEDADES  */}
          <Route path="/talento-humano/tipo-novedades" element={<TipoNovedades />} />    

          {/* NOVEDADES TURNOS  */}
          <Route path="/talento-humano/novedades-turnos" element={<NovedadesTurnos />} />  

          
          
          <Route path="/configuracion/sucursales" element={<Sucursal />} />
          <Route path="/configuracion/crear-sucursal" element={<CrearSucursalEmpresa />} />
          <Route path="/configuracion/sucursal/detalle-sucursal" element={<DetalleSucursal />} />
          <Route path="/configuracion/sucursal/editar-sucursal" element={<EditarSucursal />} />

          
          {/* EMPLOYEE TERMINALS  */}
          <Route path="/configuracion/terminales" element={<Terminals />} />
          

          
          
          <Route path="*"  element={<Navigate to={'/'} replace />} />
        </Route>
      </Routes>
  )  
}